import { Audio } from 'expo-av';
import { BlurView } from 'expo-blur';
import React, { useState, useCallback, useEffect } from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import { styles } from './styles';

const ExplorationCard = ({ selectedObject, setSelectedObject }) => {
  const { width, height } = useSafeAreaFrame();

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View style={styles.container}>
          <Text style={styles.title}>{selectedObject.title}</Text>
          <Image style={styles.image} source={selectedObject.asset} />
          <Text style={styles.description}>{selectedObject.explorationText}</Text>
          <Pressable
            onPress={() => {
              setSelectedObject(null);
            }}
            style={styles.buttonBack}>
            <Text style={styles.textBack}>Voltar</Text>
          </Pressable>
        </View>
      </BlurView>
    </View>
  );
};

export default ExplorationCard;
